import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { fetchLogoSrc } from 'assets/js/common';
import { useAppContext } from 'providers/appProvider';

const Logo = ({ at = 'auth', className, ...rest }) => {
  const [logoSrc, setLogoSrc] = useState(null);
  const { logoRefreshKey } = useAppContext(); //  watch for changes

  useEffect(() => {
    const customerId= localStorage.getItem('customerId');
    const loadLogo = async () => {
      const src = await fetchLogoSrc(customerId);
      setLogoSrc(src);
    };
    loadLogo();
  }, [logoRefreshKey]);

  return (
    <Link
      to="/dashboard"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >
        {/* {logoSrc && <img className="me-2 logo-img" src={logoSrc} alt="Logo" width={70} height={40} />} */}
        {logoSrc && <img className="me-2 logo-img" src={logoSrc} alt="Logo" />}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  className: PropTypes.string
};

export default Logo;
